export default "data:video/mp4;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiM2E0NjFmZDQ3NTE4ZDZhZjg3YjU3NWI4MTJjNDA3ODcubXA0Ijs="